<template>
    <div class="ec-search-box ec-js-search-box">
        <div class="input-group ec-search-box-input">
            <input type="search" class="form-control" v-model="search" placeholder="Rechercher"
                   @keypress="onKeyPress($event)">
            <span class="input-group-addon" :class="{ 'ec-loading': loading }">
                <i class="glyphicon glyphicon-search" v-if="!loading" @click="loadResults"></i>
                <i class="fa fa-spinner fa-spin" v-if="loading"></i>
            </span>
        </div>
        <div class="ec-search-box-results" v-if="thereAreResults || showNoResults">
            <ul v-if="labels.length">
                <li><h4>Catégories</h4></li>
                <li v-for="label in labels">
                    <a :href="label.url">
                        <img v-if="label.image" :src="label.image">
                        <span v-html="label.name"></span>
                    </a>
                </li>
            </ul>
            <ul v-if="brands.length">
                <li><h4>Marques</h4></li>
                <li v-for="brand in brands">
                    <a :href="brand.url">
                        <img v-if="brand.image" :src="brand.image">
                        <span v-html="brand.name"></span>
                    </a>
                </li>
            </ul>
            <ul v-if="bikes.length">
                <li><h4>Vélos</h4></li>
                <li v-for="bike in bikes">
                    <a :href="bike.url">
                        <img v-if="bike.image" :src="bike.image">
                        <span class="ec-bike-name" v-html="bike.name"></span>
                        <div class="ec-search-box-results-bike-price">
                            <span v-if="!bike.discount">{{ bike.price }}</span>
                            <span class="ec-price-discount" v-if="bike.discount">{{ bike.discount }}</span>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="alert alert-warning ec-search-box-no-results" v-if="showNoResults">
                Pas de résultats pour <strong>{{ search }}</strong>
            </div>
        </div>
    </div>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";

    .ec-search-box {
        position: relative;
        margin-top: $grid-gutter-width * 1.5;
        margin-bottom: $grid-gutter-width;

        .ec-search-box-input {
            border-bottom: 2px solid $ec-primary-color;

            input.form-control {
                background: none;
                border: none;
                @include box-shadow(none);
                @include border-radius(0 !important);
                padding-left: 0;
                color: $text-color;
                @include placeholder($text-muted);
            }

            .input-group-addon {
                border: none;
                background: none;
                color: $ec-primary-color;
                font-size: $ec-font-size-large;
                padding-right: 0;

                &:not(.ec-loading) {
                    cursor: pointer;
                }
            }

            i {
                height: $ec-icon-height;

                &.fa.fa-spin {
                    color: $text-color;
                    font-size: ($ec-icon-height - 2px);
                }
            }
        }

        .ec-search-box-results {
            display: block;
            position: absolute;
            min-height: 25vh;
            max-height: 60vh;
            overflow-y: auto;
            left: 0;
            right: 0;
            top: $grid-gutter-width * 1.5;
            background: $ec-color-white;
            z-index: 1;
            @include box-shadow(0 0 1px 1px $ec-primary-color);

            ul {
                width: 100%;
                margin: 0;
                padding: 0;

                li {
                    margin: 0;
                    padding: 0;
                    position: relative;

                    a, h4 {
                        line-height: 30px;
                        padding: $grid-gutter-width/3 $grid-gutter-width/2;
                    }

                    h4 {
                        margin: 12px 0 0 0;
                        font-size: $ec-font-size-base;
                        background: $ec-footer-background-color;
                        color: $ec-color-white;
                        text-transform: uppercase;
                    }

                    a {
                        display: block;
                        @include ec-flex-center();
                        justify-content: flex-start;
                        @include transition(color 0.15s ease, background 0.3s ease);

                        match, .ec-price-discount {
                            @include transition(color 0.15s ease);
                            color: $ec-primary-color;
                            font-weight: bold;
                        }

                        img {
                            max-height: $grid-gutter-width * 2.5;
                            max-width: $grid-gutter-width * 2;
                            margin-right: $grid-gutter-width / 2;
                        }

                        &:hover, &:active, &.active {
                            background: $ec-primary-color;
                            color: $ec-color-white;
                            text-decoration: none;

                            match, .ec-price-discount {
                                color: $ec-color-white;
                            }
                        }

                        .ec-bike-name {
                            padding-right: 6em;
                            @include ellipsis;
                        }
                    }
                }
            }

            .ec-search-box-results-bike-price {
                position: absolute;
                right: $grid-gutter-width/2;
                top: 0;
                bottom: 0;

                @include ec-flex-center();
                justify-content: flex-end;
            }
        }

        .ec-search-box-no-results {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            margin: 0;

            @include ec-flex-center();

            strong {
                margin-left: $grid-gutter-width/3;
            }
        }
    }

    @media (max-width: $screen-xs-max) {
        .ec-search-box {
            margin-top: $grid-gutter-width;
            margin-bottom: $grid-gutter-width / 2;

            .ec-search-box-input {
                input.form-control {
                    font-size: $ec-font-size-large;
                }

                .input-group-addon {
                    font-size: $ec-font-size-h3;
                }
            }

            .ec-search-box-results {
                max-height: 1000vh;
                position: initial;
                margin: $grid-gutter-width/6 0 $grid-gutter-width/2 0;
                @include box-shadow(none);
            }
        }
    }
</style>


<script type="text/babel">
    const GA = require('../../modules/ga');

    export default {
        props: ['searchEndpoint'],

        data: function () {
            return {
                search: '',
                xhr: null,
                labels: [],
                brands: [],
                bikes: [],
                timeout: null,
                loading: false,
                showNoResults: false
            };
        },

        watch: {
            search: function () {
                let that = this;

                this.showNoResults = false;

                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                this.timeout = setTimeout(function () {
                    that.loadResults();
                    that.timeout = null;
                }, 500);
            }
        },

        computed: {
            thereAreResults: function () {
                return this.labels && this.labels.length ||
                    this.bikes && this.bikes.length ||
                    this.brands && this.brands.length;
            }
        },

        mounted: function () {
            let that = this;

            $('body').on('click', function (ev) {
                if ($(ev.target).parents('.ec-js-search-box').length === 0) {
                    that.hideResultList();
                }
            });
        },

        methods: {
            onKeyPress: function (event) {
                if (event.keyCode === 13) {
                    this.loadResults();
                }
            },

            hideResultList: function () {
                this.labels = [];
                this.brands = [];
                this.bikes = [];

                this.showNoResults = false;
            },

            loadResults: function () {

                if (!this.search || this.search.length < 3) {
                    this.hideResultList();

                    return;
                }

                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                try {
                    this.xhr.abort();
                } catch (e) {
                }

                let payload = {
                    q: this.search
                };

                this.loading = true;
                this.showNoResults = false;

                let that = this;

                this.xhr = $.ajax({
                    url: this.searchEndpoint,
                    method: 'get',
                    data: payload,
                    success: function (data) {
                        if (data.success && data.results) {
                            that.labels = data.results.labels || [];
                            that.brands = data.results.brands || [];
                            that.bikes = data.results.bikes || [];

                            if (!that.thereAreResults) {
                                that.showNoResults = true;
                            }
                        }
                        else {
                            console.error('Wrong payload produced server error:', payload, data);
                            showServerError();
                        }
                    },
                    error: function (data) {
                        if (data && data.status === 0 && data.statusText === 'abort') {
                            return;
                        }

                        showServerError();
                    },
                    complete: function () {
                        that.loading = false;
                    }
                });

                GA.event('search', 'load', this.search);
            }
        }
    }
</script>